// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__CR_Pd","content":"GlobalSearch_content__3L1_U"};